<template>
    <div>
        <v-card
            v-if="object.photos_total && object.photos_total.length > 0"
            class="pa-0"
            outlined
            id="table_border"
        >
            <v-slide-group
                class="hidden-sm-and-down"
                v-model="model" 
                show-arrows
                mandatory
                center-active
            >
                <v-slide-item
                    v-for="item in object.photos_total"
                    :key="item.id"
                >
                    <v-avatar
                        class="ma-2"
                        color="#BDBDBD"
                        tile
                        width="267px"
                        height="200px"
                        @click.prevent="openCloseDialog()"
                    >
                        <v-img 
                            :src="item | urlUpload"
                            :lazy-src="item | urlUpload"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                                >
                                <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                ></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-avatar>
                </v-slide-item>
            </v-slide-group>

            <v-carousel 
                v-if="$vuetify.breakpoint.xsOnly"
                v-model="model"
                :cycle="cycle"
                width="auto"
                height="250px"
                hide-delimiters
            >
                <v-carousel-item
                    v-for="item in object.photos_total"
                    :key="item.id"
                    :src="item.urlremoto != null ? item.urlremoto : item.urllocal"
                    :lazy-src="item.urlremoto != null ? item.urlremoto : item.urllocal"
                    class="text-right"
                >
                     <v-chip
                        v-if="item.description != null"
                        class="ma-2"
                        color="pink"
                        label
                        text-color="white"
                        >
                        <v-icon left>
                            mdi-label
                        </v-icon>
                        {{ item.description }}
                    </v-chip>
                </v-carousel-item>
            </v-carousel> 
        </v-card>

        <!-- Dialog visit -->
        <v-dialog 
            class="d-print-none"
            v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                color="black"
                height="5px"
            >    
            </v-system-bar>   
 
            <v-card color="black">
                <div class="text-right">
                    <v-btn small color="white" outlined @click="openCloseDialog()">
                        FECHAR <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-container>
                    <v-row dense>
                        <v-col cols="12">
                            <splide-carousel-thumb :photos="object.photos_total" />
                        </v-col>  
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->

    </div>
</template>

<script>
import SplideCarouselThumb from '@/components/carousel/SplideCarouselThumb.vue'

export default {
    components: {
        SplideCarouselThumb
    },

    props: {
        object: {
            require: true,
        },
    },
    
    watch: {
        object () {   
            this.setObject()
        },
    },

    data () {
        return {
            dialog: false,    
            cycle: false, 
            model: 0,
            dialog_carousel: false,
        }
    },
    
    methods: {
        openCloseDialog(){
            this.dialog = !this.dialog
        },

        setObject(){
            this.model = 0
        }
    }
}
</script>